import * as React from 'react'

import { IMapSettings } from '~/client/src/shared/components/MapBoxViewer/mapSettings'
import {
  Drawer,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
  DrawerTrigger,
} from '~/client/src/shared/components/shadcn-ui/drawer'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import MapSettingsPanel from './MapSettingsPanel'

type IMapSettingsDrawerBaseProps = {
  settings: IMapSettings
}

type IUncontrolledProps = IMapSettingsDrawerBaseProps & {
  trigger: React.ReactElement
  open?: never
  onClose?: never
}

type IControlledProps = IMapSettingsDrawerBaseProps & {
  trigger?: never
  open: boolean
  onClose: () => void
}

type IMapSettingsDrawerProps = IUncontrolledProps | IControlledProps

const MapSettingsDrawer: React.FC<IMapSettingsDrawerProps> = props => {
  const { trigger, settings } = props as IUncontrolledProps & IControlledProps
  const [internalOpen, setInternalOpen] = React.useState(false)

  const isControlled = props.open !== undefined
  const open = isControlled ? props.open : internalOpen
  const handleClose = isControlled
    ? (props as IControlledProps).onClose
    : () => setInternalOpen(false)

  return (
    // noBodyStyles: vaul's iOS-only `position: fixed` body lock collapses the
    // full-height layout chain feeding BaseMapView's <AutoSizer>, hiding the
    // map for the drawer's full lifetime (STX1-443). This drawer has no
    // text inputs, so we don't need vaul's iOS keyboard repositioning.
    <Drawer
      open={open}
      onOpenChange={nextOpen => {
        if (isControlled) {
          if (!nextOpen) handleClose()
        } else {
          setInternalOpen(nextOpen)
        }
      }}
      noBodyStyles
    >
      {trigger && <DrawerTrigger asChild>{trigger}</DrawerTrigger>}
      {/* dvh: iOS Safari's vh is the viewport with its toolbars hidden, which put the sheet's
          bottom behind them. Same variant as the primitive's 80vh cap, so it replaces it. */}
      <DrawerContent className="tw:inset-x-0 tw:bottom-0 tw:h-auto tw:outline-none tw:data-[vaul-drawer-direction=bottom]:max-h-[80dvh]">
        <DrawerTitle className="tw:sr-only">
          {Localization.translator.mapSettings}
        </DrawerTitle>
        <DrawerDescription className="tw:sr-only">
          {Localization.translator.mapSettings}
        </DrawerDescription>
        <MapSettingsPanel fullWidth settings={settings} onClose={handleClose} />
      </DrawerContent>
    </Drawer>
  )
}

export default MapSettingsDrawer
